import React, { useEffect, useState } from "react";
import "aos/dist/aos.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "../index.css";

import Footer from "./Footer";
import heroBackground from '../images/bg_1.png';
import SimpleHeader from "./SimpleHeader";

type AuthorItem = {
  fields: {
    fullName: string;
    role: string;
    pirofilePicture: object;
  };
  metadata: any;
  sys: any;
}

type AuthorState = {
  item: AuthorItem;
  profilePicture: string;
};

type NewsState = {
  item: any;
  coverImage: string;
}

function Newsletter() {

  const [ direction, setDirection ] = useState('desc')
  const [ keyword, setKeyword ] = useState('')
  const [ newsletters, setNewsletters ] = useState<any>()
  const [ filteredItems, setFilteredItems ] = useState<any[]>([])

  const CONTENTFUL_SPACE_ID = "qitjy5hyl5up"
  const CONTENTFUL_ACCESS_TOKEN = "TKo1zCQL_v1NQmGcRQXQVqayvDSqukrdCeRlbpEedyM"

  const contentfulEndpointNewsletter = `https://cdn.contentful.com/spaces/${CONTENTFUL_SPACE_ID}/environments/master/entries?access_token=${CONTENTFUL_ACCESS_TOKEN}&content_type=newsletter`;

  const handleChange = (e:any) => {
    setKeyword(e.target.value)
    setFilteredItems(newsletters.items.filter((item:any)=>{
      return (item.fields.title.toUpperCase().includes(e.target.value.toUpperCase()))
    }))
  }

  const sortData = (direction:any) => {
    const newFilteredItems = [...filteredItems].sort(
      function(a:any,b:any)
      {
        if (direction=='desc') 
          return b.fields.date.localeCompare(a.fields.date); 
        else 
          return a.fields.date.localeCompare(b.fields.date);
      }
    )
    setDirection(direction)
    setFilteredItems(newFilteredItems) 
  }
  
  useEffect(()=>{
    (async () => {
      try {
        const res = await fetch(contentfulEndpointNewsletter);
        const data = await res.json();
        setNewsletters(data)
        const newFilteredItems = [...data.items].sort(
          function(a:any,b:any)
          {
            if (direction=='desc') 
              return b.fields.date.localeCompare(a.fields.date); 
            else 
              return a.fields.date.localeCompare(b.fields.date);
          }
        )
        setFilteredItems(newFilteredItems)
        console.log(data)
      } catch (error) {
        console.log(error);
      }
    })();
  },[])

  useEffect(()=>{
    console.log(filteredItems)
  },[filteredItems])

  return (
    <>
      <section
        id="hero"
        style={{backgroundImage:`url(${heroBackground})`}}
        className="bg-no-repeat w-full bg-center bg-cover pt-80 pb-6 h-[40vh] brightness-100"
      >
      </section>
      <SimpleHeader/>
      <section>
        <div className="pb-[250px]">
          <div className="grid grid-cols-1 md:grid-cols-3">
            <div className="col-span-1 pt-10 pl-10 ">
                <h1 className="text-[#0c2957] text-[2.3rem] w-1/2 font-bold mb-10 ms-8">Archivio Newsletter</h1>
                <div className="bg-[#e0f9fd] w-full pt-12 pb-10 pl-10 pr-16">
                    <h1 className="w-[200px] text-3xl text-[#0c2957] font-bold mb-6">
                        Iscriviti alla newsletter
                    </h1>
                    <p className="text-lg font-semibold">
                        Iscriviti per ricevere periodicamente notizie e aggiornamenti sul mondo 
                        di Italy HLG, incluse le nostre iniziative in anteprima, i nostri eventi 
                        e quello che nella nostra industria ci ispira e ci guida. Iscrivendoti 
                        accetti <span>questi termini.</span>
                    </p>
                    <form className="w-4/5 mb-10" action="">
                        <input className="w-full h-[60x] bg-[#e5f8fc] text-md py-7 border-b-[2px]" type="email" placeholder="Your email" />
                        <button className="bg-[#0c2957] text-xs font-bold  w-full py-7 text-white tracking-widest">INVIA</button>
                    </form>
                </div>
            </div>
            <div className="col-span-2 z-10  md:mt-[-120px]">
              <div className=" z-50 bg-white pt-[100px] pl-[120px]">
                <div className="grid grid-cols-3 gap-4">
                  <div className="col-span-2 flex mb-0 w-full">
                    <input onChange={handleChange} type="text" placeholder="Cerca.." className="border border-black text-lg p-3 w-[30rem]" />
                  </div>
                  <div className="col-span-1 flex flex-col mt-auto">
                    <p onClick={()=>{if(direction=='desc') sortData('asc'); else sortData('desc');}} className="text-sm hover:font-bold cursor-pointer">Ordina per data &nbsp;<span className="text-[#00a695] font-bold">{`${direction=='desc'?'⬆':'⬇'}`}</span></p>
                  </div>
                </div>
                
                {filteredItems.map((item:any, idx:number)=>{
                    return(
                      <div key={idx} className="mb-20 mr-64">
                        <h1 className="text-[1.5rem] font-bold text-[#0c2957] hover:underline leading-[2.5rem] mt-12 mb-6">{item.fields.title}</h1>
                        <p className="text-lg font-[600] text-[#444444]  mb-4">Inviata il <span className="text-[#00a695] text-sm font-[500]">{item.fields.date}</span></p>
                        <a target="_blank" href={newsletters?.includes.Asset.filter((asset:any)=>{return asset.sys.id==item.fields.pdf.sys.id})[0].fields.file.url} className="text-[1.3rem] text-[#00a695] font-semibold hover:underline cursor-pointer">Download</a>
                      </div>
                    )
                  })     
                } 
              </div>
            </div>
          </div>
        </div>

      </section>
      <Footer></Footer>
    </>
  );
}

export default Newsletter;
